// extracted by mini-css-extract-plugin
export var container = "_sh-0";
export var dotAnimation = "_sh-2";
export var dotsLoading = "_sh-1";